module.exports = __webpack_public_path__ + "img/141.8f5748c5.jpg";